import { render, staticRenderFns } from "./rule_config.vue?vue&type=template&id=5fadf84e&scoped=true"
import script from "./rule_config.vue?vue&type=script&lang=js"
export * from "./rule_config.vue?vue&type=script&lang=js"
import style0 from "./rule_config.vue?vue&type=style&index=0&id=5fadf84e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fadf84e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fadf84e')) {
      api.createRecord('5fadf84e', component.options)
    } else {
      api.reload('5fadf84e', component.options)
    }
    module.hot.accept("./rule_config.vue?vue&type=template&id=5fadf84e&scoped=true", function () {
      api.rerender('5fadf84e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/performance_manage/performace_target_report/components/rule_config.vue"
export default component.exports